import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconSwappingM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.146447 10.1464C-0.0488155 10.3417 -0.0488155 10.6583 0.146447 10.8536L3.14645 13.8536C3.34171 14.0488 3.65829 14.0488 3.85355 13.8536C4.04882 13.6583 4.04882 13.3417 3.85355 13.1464L1.70711 11H11.5C11.7761 11 12 10.7761 12 10.5C12 10.2239 11.7761 10 11.5 10H1.70711L3.85355 7.85355C4.04882 7.65829 4.04882 7.34171 3.85355 7.14645C3.65829 6.95118 3.34171 6.95118 3.14645 7.14645L0.146447 10.1464ZM11.8595 3.84752C12.0468 3.65371 12.0468 3.34629 11.8595 3.15248L8.95939 0.152483C8.76746 -0.0460567 8.45092 -0.0514164 8.25239 0.140512C8.05385 0.33244 8.04849 0.648977 8.24041 0.847517L10.3212 3L0.500096 3C0.223954 3 9.61138e-05 3.22386 9.60896e-05 3.5C9.60655e-05 3.77614 0.223954 4 0.500096 4L10.3212 4L8.24041 6.15248C8.04849 6.35102 8.05385 6.66756 8.25239 6.85949C8.45092 7.05142 8.76746 7.04606 8.95939 6.84752L11.8595 3.84752Z" />
  </svg>
)

export const IconSwapping = createIcon({
  name: 'IconSwapping',
  l: IconSwappingM,
  m: IconSwappingM,
  s: IconSwappingM,
  xs: IconSwappingM,
})
